// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HnAw","newExpiryDate":"styles_newExpiryDate__hy7vq","footer":"styles_footer__2yWQp"};